import { RetailerLogo } from '@app/components';

export class PlanningSummaryRetailer {
    code: string;
    name: string
    retailerLogo: RetailerLogo;
    constructor(code: string, name: string){
        this.code = code;
        this.name = name;
        this.retailerLogo = new RetailerLogo(name);
    }
}

export class PlanningSummaryNbMission {
    done: number = 0;
    planned: number = 0;
    all: number = 0;
}

export class PlanningSummarySector {
    name: string;
    nbMissions: Map<string, PlanningSummaryNbMission> = new Map();    
    constructor(name: string){
        this.name = name;
    }
}

export class PlanningSummaryArea {
    name: string;
    sectors: Array<PlanningSummarySector> = [];
    nbMissions: Map<string, PlanningSummaryNbMission> = new Map();    
    constructor(name: string){
        this.name = name;
    }
}

export class PlanningSummary {
    retailers: Array<PlanningSummaryRetailer> = [];
    areas: Array<PlanningSummaryArea> = [];
    nbMissions: Map<string, PlanningSummaryNbMission> = new Map();    
}